module.exports = __webpack_public_path__ + "static/media/crazy-cups.0f279999.png";